module.exports = __webpack_public_path__ + "img/Support24.dfff14b3.svg";